import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AssetManagementService } from '../../../../services/asset-management.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService, NbComponentStatus } from '@nebular/theme';

@Component({
  selector: 'app-update-data',
  templateUrl: './update-data.component.html',
  styleUrls: ['./update-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateDataComponent implements OnInit {

  assetIds: string;
  keyCodeList: any;
  oilTypeAsset: any;
  purchaseGroups: any;
  bodyStyleConfigurations: any;
  listEngineManufacturers: any;
  severityOfServices: any;
  assetDetailForm: UntypedFormGroup;
  assetDetailData: any;
  listEngineSizes: any;
  licenseState: any;
  leasingCompany: any;
  assetTypeGroups: any;
  assetMakes: any;
  public loading = false;
  updateAssetDetails: any;

  destroyByClick = true;
  duration = 5000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = false;
  statusSuccess = 'success';
  statusFailure = 'danger';
  message: string;

  constructor(
    private assetManagementService: AssetManagementService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private toastrService: NbToastrService,
  ) {

  }

  ngOnInit() {
    this.assetIds = this.assetManagementService.getAssetId().toString();
    this.setKeyCode();
    this.assetDetailForm = this.formBuilder.group({
      asset_Id: [''],
      location_Id: [''],
      serial_number: [''],
      make_year: [''],
      make_id: [''],
      vehical_model: [''],
      vehical_color: [''],
      serviceDate: [''],
      active_sold_date: [''],
      leasing_company: [''],
      purchase_group: [''],
      asset_description: [''],
      detailed_description: [''],
      hot_alert: [''],
      equipment_vocation: [''],
      equipment_category: [''],
      license_number: [''],
      license_state: [''],
      license_exp_date: [''],
      engine_size: [''],
      asset_typeGroup: [''],
      severity_ofService: [''],
      body_styleConfiguration: [''],
      engine_manufacturer: [''],
      axle_configuration: [''],
      cab_type: [''],
      power_source: [''],
      transmission_type: [''],
      dOT_number: [''],
      trailer_length: [''],
      vehicle_statusCode: [''],
      power_takeOff: [''],
      oil_type: [''],
      asset_Class: [''],
      life_cycleExpiration: [''],
      last_validatedMileage: [''],
      current_assumedMileage: [''],
      last_validatedHours: [''],
      current_assumedHours: [''],
      last_mileage_update_date: [''],
      last_hours_update_date: [''],
      managed_startDate: [''],
      managed_endDate: [''],
      current_assumed_miles_updated_date: [''],
      current_assumed_hours_updated_date: [''],
      avg_hrsPerMonth: [''],
      avg_milesPerMonth: [''],
      is_managed: [''],
      state_inspection: ['']
    });

  }

  setKeyCode() {
    this.assetManagementService.getKeyCodeValues().subscribe(res => {
      this.keyCodeList = res.assetResponse;
      this.setAssetMakes();
    });
  }

  setOilType() {
    this.assetManagementService.getOilTypeAssetValues().subscribe(res => {
      this.oilTypeAsset = res.assetResponse;
      this.setPurchaseGroup();
    });
  }

  setPurchaseGroup() {
    this.assetManagementService.getPurchaseGroups(sessionStorage.getItem('fleetCustomerId')).subscribe(res => {
      this.purchaseGroups = res.assetResponse;
      this.setBodyStyleConfigurations();
    });
  }

  setBodyStyleConfigurations() {
    this.assetManagementService.getBodyStyleConfigurations().subscribe(res => {
      this.bodyStyleConfigurations = res.assetResponse;
      this.setListEngineManufacturers();
    });
  }

  setListEngineManufacturers() {
    this.assetManagementService.getListEngineManufacturers().subscribe(res => {
      this.listEngineManufacturers = res.assetResponse;
      this.setSeverityOfServices();
    });
  }

  setSeverityOfServices() {
    this.assetManagementService.getSeverityOfServices().subscribe(res => {
      this.severityOfServices = res.assetResponse;
      this.setListEngineSizes();
    });
  }

  setListEngineSizes() {
    this.assetManagementService.getListEngineSizes().subscribe(res => {
      this.listEngineSizes = res.assetResponse;
      this.setState();
    })
  }

  setState() {
    this.assetManagementService.getState().subscribe(res => {
      this.licenseState = res.assetResponse;
      this.setLeasingCompany();
    })
  }

  setLeasingCompany() {
    this.assetManagementService.getLeasingCompany().subscribe(res => {
      this.leasingCompany = res.assetResponse;
      this.setAssetTypeGroups();
    })
  }

  setAssetTypeGroups() {
    this.assetManagementService.getAssetTypeGroups().subscribe(res => {
      this.assetTypeGroups = res.assetResponse;
    })
  }
  setAssetMakes() {
    this.assetManagementService.getAssetMakes().subscribe(res => {
      this.assetMakes = res.assetResponse;
      this.setOilType();
    })
  }

  dataSave() {
    this.loading = true;
    this.assetDetailForm.controls['asset_Id'].setValue(this.assetIds);
    var serviceDate = this.datePipe.transform(this.assetDetailForm.controls.serviceDate.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['serviceDate'].setValue(serviceDate);
    var active_sold_date = this.datePipe.transform(this.assetDetailForm.controls.active_sold_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['active_sold_date'].setValue(active_sold_date);
    var license_exp_date = this.datePipe.transform(this.assetDetailForm.controls.license_exp_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['license_exp_date'].setValue(license_exp_date);
    var last_mileage_update_date = this.datePipe.transform(this.assetDetailForm.controls.last_mileage_update_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['last_mileage_update_date'].setValue(last_mileage_update_date);
    var last_hours_update_date = this.datePipe.transform(this.assetDetailForm.controls.last_hours_update_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['last_hours_update_date'].setValue(last_hours_update_date);
    var current_assumed_miles_updated_date = this.datePipe.transform(this.assetDetailForm.controls.current_assumed_miles_updated_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['current_assumed_miles_updated_date'].setValue(current_assumed_miles_updated_date);
    var current_assumed_hours_updated_date = this.datePipe.transform(this.assetDetailForm.controls.current_assumed_hours_updated_date.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['current_assumed_hours_updated_date'].setValue(current_assumed_hours_updated_date);
    var managed_startDate = this.datePipe.transform(this.assetDetailForm.controls.managed_startDate.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['managed_startDate'].setValue(managed_startDate);
    var managed_endDate = this.datePipe.transform(this.assetDetailForm.controls.managed_endDate.value, "yyyy-MM-dd");
    this.assetDetailForm.controls['managed_endDate'].setValue(managed_endDate);

    this.updateAssetDetails = this.assetDetailForm.value;
    this.updateAssetDetails.serviceDate != null ? this.updateAssetDetails.serviceDate : this.updateAssetDetails.serviceDate = "0000-00-00";
    this.updateAssetDetails.active_sold_date != null ? this.updateAssetDetails.active_sold_date : this.updateAssetDetails.active_sold_date = "0000-00-00";
    this.updateAssetDetails.license_exp_date != null ? this.updateAssetDetails.license_exp_date : this.updateAssetDetails.license_exp_date = "0000-00-00";
    this.updateAssetDetails.last_mileage_update_date != null ? this.updateAssetDetails.last_mileage_update_date : this.updateAssetDetails.last_mileage_update_date = "0000-00-00";
    this.updateAssetDetails.last_hours_update_date != null ? this.updateAssetDetails.last_hours_update_date : this.updateAssetDetails.last_hours_update_date = "0000-00-00";
    this.updateAssetDetails.current_assumed_miles_updated_date != null ? this.updateAssetDetails.current_assumed_miles_updated_date : this.updateAssetDetails.current_assumed_miles_updated_date = "0000-00-00";
    this.updateAssetDetails.current_assumed_hours_updated_date != null ? this.updateAssetDetails.current_assumed_hours_updated_date : this.updateAssetDetails.current_assumed_hours_updated_date = "0000-00-00";
    this.updateAssetDetails.managed_startDate != null ? this.updateAssetDetails.managed_startDate : this.updateAssetDetails.managed_startDate = "0000-00-00";
    this.updateAssetDetails.managed_endDate != null ? this.updateAssetDetails.managed_endDate : this.updateAssetDetails.managed_endDate = "0000-00-00";
    this.updateAssetDetails.is_managed == true ? this.updateAssetDetails.is_managed = 1 : this.updateAssetDetails.is_managed = 0;
    this.updateAssetDetails.state_inspection == true ? this.updateAssetDetails.state_inspection = 1 : this.updateAssetDetails.state_inspection = 0;
    this.assetManagementService.updateAssetDetails(this.updateAssetDetails).subscribe(res => {
      if (res > 0) {
        this.message = "Updated successfully.!";
        this.showToast('success', this.position, this.message);
        this.loading = false;
      } else {
        this.message = "Failed to update.!";
        this.showToast('warning', this.position, this.message);
        this.loading = false;
      }
      this.loading = false;
    }, (error: HttpErrorResponse) => {
      this.loading = false;
      console.error('UpdateDataComponent_dataSave', error);
    });
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const toastFooter = `Asset Id's: ${this.assetIds}`;
    const titleContent = body;
    this.toastrService.show(
      toastFooter,
      `${titleContent}`,
      config);
  }

}
